module.exports = __webpack_public_path__ + "static/media/twitter.da3e3b06.svg";